module.exports = __webpack_public_path__ + "static/media/9-Hearts.32d21d26.svg";